import React from 'react'
import PropTypes from 'prop-types'
import SweetAlert from 'react-bootstrap-sweetalert'
import withStyles from '@material-ui/core/styles/withStyles'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormGroup from '@material-ui/core/FormGroup'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import CustomInput from 'components/CustomInput/CustomInput'
import OperationCardItem from 'views/Components/OperationCardItem.jsx'
import { connect } from 'react-redux'
import { renderSnackbar } from 'actions/snackbar'
import api from 'api'
import dashboardStyle from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle'
import buttonStyle from 'assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx'
import customInputStyle from 'assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx'
import validate, { constraints } from "services/formValidator"
import { getUserToken } from '../../services/utils';

const style = {
  ...dashboardStyle,
  ...buttonStyle,
  labelRootError: customInputStyle.labelRootError,
  myCardBody: {
    minHeight: '150px'
  },
  textCenter: {
    textAlign: 'center'
  }
}

const sign_constraints = {
  phone: [constraints.isRequired, constraints.matchPhone],
  optin_contract: [constraints.isRequired]
}

class OperationsList extends React.Component {
  state = {
    alert_phone: false,
    alert_code: false,
    alert_success: false,
    errors: {},
    error_code: '',
    phone: '',
    optin_contract: false,
    code: '',
    to_signed: null
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this)
  }


  onChange = e => {
    if (!(e.target.name === 'phone' && e.target.value.length > 9)) {
      this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value })
    }
  }

  hideAlert() {
    this.setState({
      alert_phone: false,
      optin_contract: false,
      to_signed: null
    });
  }

  signConfirmAlert(operation) {
    this.setState({
      to_signed: operation,
      alert_phone: true
    });
  }

  successSignAlert() {
    const { to_signed, phone, optin_contract } = this.state
    const errors = validate({phone: phone, optin_contract: optin_contract}, sign_constraints)

    if (Object.keys(errors).length === 0) {
      api.operations.send_code({ operation: to_signed.id, phone: phone }).then(() => {
        this.setState({ alert_phone: false, alert_code: true })
      })
      .catch((err) => this.setState({ error_phone: err.response.data.violations[0].message }))
    } else {
      this.setState({ errors: errors })
    }
  }

  signOperation() {
    const { to_signed, code } = this.state

    api.operations.sign_operation(to_signed.id, getUserToken().id, { validateCode: code})
      .then(() => {
        this.setState({ alert_code: true })
        api.operations.my_operations()
          .then(resp => {
            this.success()
            this.setState({operations: resp.data['hydra:member']})
          })
          .catch(err => (err))
      })
      .catch((err) => {
        this.setState({ error_code: err.response.data.violations[0].message })
      })
  }

  success() {
    this.setState({ alert_code: false, alert_success: true });
  }

  render() {
    const { classes, progress, operations } = this.props
    const { to_signed, phone, errors, optin_contract, alert_phone, alert_code, alert_success, error_code } = this.state

    return (
      <React.Fragment>
        <SweetAlert
          success
          show={alert_success}
          style={{ display: "block", marginTop: "-100px" }}
          title="Succès!"
          onConfirm={() => this.setState({ alert_success: false })}
          onCancel={() => this.setState({ alert_success: false })}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
        >
          Votre signature a bien été pris en compte.
        </SweetAlert>
        <SweetAlert
          show={alert_phone}
          style={{ display: 'block', marginTop: '-100px' }}
          title='SIGNER LE CONTRAT'
          onConfirm={this.successSignAlert.bind(this)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            classes.button + ' ' + classes.success
          }
          cancelBtnCssClass={
            classes.button + ' ' + classes.danger
          }
          confirmBtnText='Envoyer'
          cancelBtnText='Annuler'
          showCancel
        >
        <p>Saisissez uniquement les 9 chiffres de votre numéro de téléphone mobile, sans le préfixe « 0 ».</p>
        <GridContainer>
          <GridItem xs={3}>
            <CustomInput
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                disabled: true,
                value: '+33'
              }}
            />
          </GridItem>
          <GridItem xs={9}>
            <CustomInput
              error={!!errors.phone}
              helpText={errors.phone}
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                name: 'phone',
                placeholder: 'Veuillez saisir votre numéro de téléphone',
                onChange: this.onChange,
                value: phone
              }}
            />
          </GridItem>
          <GridItem xs={12}>
            {!!to_signed && !!to_signed.contract && <FormGroup row>
              <FormControlLabel
                label={<span>J'ai pris connaissance du <a href={`${process.env.REACT_APP_BACKEND_URL}/media/${to_signed.contract.contentUrl}`} target="_blank">contrat de l'offre.</a></span>}
                control={<Checkbox
                  color='primary'
                  onChange={this.onChange}
                  checked={optin_contract}
                  name='optin_contract'
                />}
              />
              {!!errors.optin_contract && <FormHelperText className={classes.labelRootError}>Veuillez prendre connaisance du contrat de l'offre</FormHelperText>}
            </FormGroup>}
          </GridItem>
        </GridContainer>
        </SweetAlert>
        <SweetAlert
            show={alert_code}
            style={{ display: 'block', marginTop: '-100px' }}
            title='Entrer votre code de validation!'
            onConfirm={this.signOperation.bind(this)}
            onCancel={() => this.setState({ alert_code: false })}
            confirmBtnCssClass={
              classes.button + ' ' + classes.success
            }
          >
          <CustomInput 
            formControlProps={{
              fullWidth: true
            }}
            error={!!error_code}
            helpText={error_code}
            inputProps={{
              name: 'code',
              placeholder: 'Veuillez saisir le code reçu par sms.',
              onChange: this.onChange.bind(this)
            }}
          />
        </SweetAlert>
        <GridContainer justify='center'>
          {0 === operations.length && !progress && <Typography variant="title" gutterBottom color="error">
            Aucune opération disponible pour le moment.
          </Typography>}
          {operations.map((ope, key) => (
           
            <GridItem xs={12} sm={12} md={12}>
              <OperationCardItem classes={classes} signConfirmAlert={this.signConfirmAlert.bind(this, ope)} operation={ope} />
            </GridItem>
          ))}
        </GridContainer>
      </React.Fragment>
    )
  }
}

OperationsList.propTypes = {
  classes: PropTypes.object.isRequired,
  operations: PropTypes.array.isRequired
}

export default connect(null, { renderSnackbar })(withStyles(style)(OperationsList))



// WEBPACK FOOTER //
// ./src/views/Components/OperationsList.jsx